<template>
<div id="huozhu">
	<h2 class="h2top">OWNER INVITED</h2>
	<h2 class="h2bottom">货主邀请</h2>
	<div class="lineClass"></div>
	<img style="width:100%" v-lazy="'../../static/img/1234.jpg'" alt="">
</div>
</template>

<script>
export default {
data () {
return {}
},
// 生命周期 - 创建完成（访问当前this实例）
created () {},
// 生命周期 - 挂载完成（访问DOM元素）
mounted () {}
}
</script>
<style scoped>
#huozhu{
	margin-top: 5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/huozhu.vue